'use client';

import dynamic from 'next/dynamic';
import DesktopNavigation from './desktop-navigation';
import {NavbarProps} from "./navbar.types";

// Mobile navigation pulls in Radix Dialog (Sheet) + Accordion. Desktop never
// renders this branch (CSS lg:hidden), so loading the module lazily keeps
// those modules out of the initial client bundle on desktop. On mobile the
// trigger appears after hydration — small ~100ms delay on slow networks.
const MobileNavigation = dynamic(() => import('./mobile-navigation'), {
  ssr: false,
});

export default function Navbar({
  pages,
  currentPath,
  actionButton,
  languages = [],
  variant,
  showLanguageSwitcher = true,
  mobileMenuSlidePosition = 'left',
  mobileMenuOpen,
  onMobileMenuOpenChange,
}: NavbarProps) {
  return (
    <>
      <DesktopNavigation
        pages={pages}
        currentPath={currentPath}
        languages={languages}
        variant={variant}
        actionButton={actionButton}
        showLanguageSwitcher={showLanguageSwitcher}
      />

      <MobileNavigation
        pages={pages}
        currentPath={currentPath}
        languages={languages}
        variant={variant}
        actionButton={actionButton}
        showLanguageSwitcher={showLanguageSwitcher}
        mobileMenuSlidePosition={mobileMenuSlidePosition}
        mobileMenuOpen={mobileMenuOpen}
        onMobileMenuOpenChange={onMobileMenuOpenChange}
      />
    </>
  );
}

export {Navbar};
